/**
 * Created by chenqifeng on 2016/8/26.
 */

import $ from 'jquery';
import Vue from 'vue';
import _ from '_';

/*暴露的全局变量，由控制台和ssr环境直接使用，不可删除*/
window.$ = window.jQuery || $;
window.Vue = window.vue = window.Vue || window.vue || Vue;
window._ = window._ || _;

function Maple(selector,options){
    return new Maple.prototype.init(selector,options);
}
Maple.prototype.init=function(selector,options){};
Maple.prototype.init.prototype=Maple.prototype;


export default Maple;




